import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/lobby/page.tsx");
